<template>
  <div id="credit_2991">
    <AddEntity
      ref="addEntity"
      entity-name="credit2991"
      :display-button="false"
      @refresh="
        $store.dispatch(`${namespace}/fetchData`);
        $emit('refresh');
      "
    />
    <b-row>
      <b-col
        id="deposits"
        cols="4"
      >
        <strong>Deposits&nbsp;:&nbsp;</strong>
        <output>{{ deposits | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col
        id="recycling_carryover"
        cols="4"
      >
        <strong>Recycling carryover&nbsp;:&nbsp;</strong>
        <output>{{ recyclingCarryover | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col
        id="total"
        cols="4"
      >
        <strong>Total&nbsp;: </strong>
        <output>{{ total | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col cols="12">
        <GenericTable
          endpoint-url="/credit2991"
          :name="namespace"
          :actions="actions"
          :colonnes="colonnes"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters"
          :display-archive-checkbox="false"
          right-button
          @action-callback="dispatchAction"
          @row-click="openDetails"
        >
          <button
            class="btn right-button"
            @click="exportSimple"
          >
            Exporter tous les crédits 1380
          </button>
        </GenericTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";

import mixinBudget from "@/mixins/mixinBudget";

import { roundNumber, verboseColCreditForTable } from "@/modules/utils";

export default {
  name: "Credit2991",
  components: { GenericTable },
  mixins: [mixinBudget],
  data() {
    return {
      colonnes: [
        { key: "date_reception", defaultOrder: true },
        { key: "caissiere" },
        { key: "origine" },
        { key: "facture__numero" },
        { key: "mois" },
        { key: "montant_euros" },
        { key: "taux_change" },
        { key: "montant_dollars" },
      ],
      filterableCol: ["libelle", "budget", "date_reception", "caissiere"],
    };
  },
  computed: {
    extraFilters() {
      if (this.annee === null) {
        return {
          budget: this.budget,
          date_reception__isnull: true,
        };
      }
      return {
        budget: this.budget,
        date_reception__gte: `01/10/${this.annee - 1}`,
        date_reception__lte: `30/09/${this.annee}`,
      };
    },
    namespace() {
      return `Budget${this.budget}Credit`;
    },
    deposits() {
      return roundNumber(this.infoBudgets[this.budget].credits);
    },
    recyclingCarryover() {
      return roundNumber(this.infoBudgets[this.budget].carryover);
    },
    total() {
      return roundNumber(
        this.infoBudgets[this.budget].credits
          + this.infoBudgets[this.budget].carryover,
      );
    },
  },
  mounted() {
    this.$store.commit(
      `${this.namespace}/setFormatDataFunction`,
      verboseColCreditForTable,
    );
  },
};
</script>

<style lang="scss">
#credit_2991 .table-content {
  .date_reception { width: 100px; }
  .caissiere { width: 120px; }
  .origine { min-width: 300px; }
  .facture { width: 200px; }
  .mois { width: 150px; }
  .montant_euros,
  .montant_dollars { width: 150px; }
  .taux_change { width: 150px; }
}
</style>
